export const CREATE_VISITALERT = "CREATE_VISITALERT";
export const RETRIEVE_VISITALERT = "RETRIEVE_VISITALERT";
export const RETRIEVESINGLE_VISITALERT = "RETRIEVESINGLE_VISITALERT";
export const UPDATE_VISITALERT = "UPDATE_VISITALERT";
export const DELETE_VISITALERT = "DELETE_VISITALERT";


